import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
    IconButton,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { getDoc, doc, serverTimestamp, updateDoc, deleteDoc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import CloseIcon from "@mui/icons-material/Close";

function InfoEdit() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [param, setParam] = useState("");

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const handleUpdateClick = async () => {
        try {
            const documentRef = doc(db, "houseRule", param);
            await updateDoc(documentRef, {
                title: title,
                description: description,
                updateAt: serverTimestamp(),
            });
        } catch (error) {
            console.error("error: ", error);
        }
        setSaveOpen(true);
    };

    const [saveOpen, setSaveOpen] = useState(false);
    const handleSaved = () => {
        window.scrollTo(0, 0);
        navigate("/house-rule", { replace: true });
    };

    const [loadButton, setLoadButton] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const handleDeleteClose = () => {
        setDeleteOpen(false);
    };

    const handleDelete = () => {
        setDeleteOpen(true);
    };

    const handleDeleteComp = async () => {
        setLoadButton(true);

        const ruleRef = doc(db, "houseRule", param);
        await deleteDoc(ruleRef);

        setLoadButton(false);
        setDeleteCompOpen(true);
    };

    const [deleteCompOpen, setDeleteCompOpen] = useState(false);
    const handleDeleteComped = () => {
        window.scrollTo(0, 0);
        navigate("/house-rule", { replace: true });
    };

    const fetchData = async () => {
        const params = window.location.pathname.split("/")[2];
        setParam(params);

        const ruleRef = doc(db, "houseRule", params);
        const ruleSnap = await getDoc(ruleRef);
        setTitle(ruleSnap.data().title);
        setDescription(ruleSnap.data().description);

        setLoading(false);
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged((userLogin) => {
            if (userLogin) {
                fetchData();
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Info Edit - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                <Container>
                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ mt: 10 }}
                    >
                        <Typography variant="h6">ハウスルール編集</Typography>
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ m: 3 }}
                    >
                        <TextField
                            variant="filled"
                            label="タイトル"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            sx={{ minWidth: 350 }}
                        />
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ m: 3 }}
                    >
                        <TextField
                            variant="filled"
                            label="内容"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            multiline
                            rows={10}
                            sx={{ minWidth: 350 }}
                        />
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ mt: 5 }}
                    >
                        <Button variant="contained" onClick={handleUpdateClick} size="large" sx={{ width: "350px" }}>
                            更新
                        </Button>
                    </Box>

                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                        sx={{ mt: 3, mb: 2 }}
                    >
                        <Button color="error" variant="contained" onClick={handleDelete} size="large" sx={{ width: "350px" }}>
                            削除
                        </Button>
                    </Box>
                </Container>
            </Container>

            <Dialog open={saveOpen}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    更新しました
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", display: "flex", mb: 2 }}>
                    <Button variant="contained" sx={{ width: "100px" }} onClick={handleSaved}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteOpen} onClose={handleDeleteClose}>
                <DialogTitle sx={{ mb: 2, minWidth: 263 }}>
                    <IconButton
                        onClick={handleDeleteClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography style={{ display: "flex", justifyContent: "center" }}>削除しますか？</Typography>
                </DialogContent>
                <DialogActions>
                    <LoadingButton onClick={handleDeleteClose} variant="outlined" loading={loadButton} loadingIndicator="削除中">
                        キャンセル
                    </LoadingButton>
                    <LoadingButton onClick={handleDeleteComp} variant="contained" loading={loadButton}>
                        OK
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteCompOpen}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    ハウスルールを削除しました
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", display: "flex", mb: 2 }}>
                    <Button variant="contained" sx={{ width: "100px" }} onClick={handleDeleteComped}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default InfoEdit;
